import React, {} from "react"

export default function CreatePriceStr(price, currency='GBP', return_symbol=true, divider=null) {
   if (divider){
      var price = Math.round(price/divider)
   }
   var price = String(price)
   if (price === '0'){
      if (return_symbol){
         if (currency === 'GBP'){
            return ('£' + price)
         } else if (currency === 'USD'){
            return ('$' + price)
         } else if (currency === 'EUR'){
            return ('€' + price)
         } else if (currency === 'SEK'){
            return (price + ' kr')
         } else if (currency === 'AUD'){
            return ('AU$' + price)
         } else if (currency === 'CAD'){
            return ('CA$' + price)
         } else if (currency === 'NZD'){
            return ('NZ$' + price)
         }
      } else {
         return price
      }
   }
   var price_pre = price.slice(0, price.length - 2)
   if (price_pre.length > 3){
      var price_pre1 = price_pre.slice(0, price_pre.length - 3)
      var price_pre2 = price_pre.slice(price_pre.length - 3)
   }
   var price_post = price.slice(price.length - 2, price.length)
   if (return_symbol){
      if (price_pre.length <= 3){
         if (currency === 'GBP'){
            return ('£' + price_pre + '.' + price_post)
         } else if (currency === 'USD'){
            return ('$' + price_pre + '.' + price_post)
         } else if (currency === 'EUR'){
            return ('€' + price_pre + '.' + price_post)
         } else if (currency === 'SEK'){
            return (price_pre + '.' + price_post + ' kr')
         } else if (currency === 'AUD'){
            return ('AU$' + price_pre + '.' + price_post)
         } else if (currency === 'CAD'){
            return ('CA$' + price_pre + '.' + price_post)
         } else if (currency === 'NZD'){
            return ('NZ$' + price_pre + '.' + price_post)
         }
      } else {
         if (currency === 'GBP'){
            return ('£' + price_pre1 + ',' + price_pre2 + '.' + price_post)
         } else if (currency === 'USD'){
            return ('$' + price_pre1 + ',' + price_pre2 + '.' + price_post)
         } else if (currency === 'EUR'){
            return ('€' + price_pre1 + ',' + price_pre2 + '.' + price_post)
         } else if (currency === 'SEK'){
            return (price_pre1 + ',' + price_pre2 + '.' + price_post + ' kr')
         } else if (currency === 'AUD'){
            return ('AU$' + price_pre1 + ',' + price_pre2 + '.' + price_post)
         } else if (currency === 'CAD'){
            return ('CA$' + price_pre1 + ',' + price_pre2 + '.' + price_post)
         } else if (currency === 'NZD'){
            return ('NZ$' + price_pre1 + ',' + price_pre2 + '.' + price_post)
         }
      }
   } else {
      if (price_pre.length > 3){
         return (price_pre1 + ',' + price_pre2 + '.' + price_post)
      } else {
         return (price_pre + '.' + price_post)
      }
   }
}
